module.exports = __webpack_public_path__ + "img/521.a42e013c.jpg";